import React from "react";
import moment from "moment";
import { storage } from "../../../dependencies/store/storage";
import { ROLES } from "../../../constants/role";

const TableColumn = ({ handleEdit, handleView, pageNo = 0, size = 10 }) => {
  const role = storage.getUserRole();
  const canManage = role === ROLES.ADMIN || role === ROLES.CORDINATOR;
  return [
    {
      dataField: "",
      text: "S.No",
      formatter: (cell, row, rowIndex) => {
        return pageNo * size + (rowIndex + 1);
      },
    },
    {
      dataField: "serviceNumber",
      text: "Service Id",
      sort: false,
      formatter: (cell, row) => {
        return cell;
      },
    },
    {
      dataField: "serviceName",
      text: "Service Name",
      sort: false,
      formatter: (cell, row) => {
        return cell;
      },
    },
    {
      dataField: "customerName",
      text: "Patient Name",
      formatter: (cell, row, rowIndex) => {
        return cell
      },
    },
    {
      dataField: "age",
      text: "Age",
      formatter: (cell, row, rowIndex) => {
        return cell
      },
    },

    {
      dataField: "gender",
      text: "gender",
      formatter: (cell, row, rowIndex) => {
        return cell
      },
    },
    {
      dataField: "medicalProblem",
      text: "Medical Problem",
      formatter: (cell, row, rowIndex) => {
        return cell
      },
    },

    {
      dataField: "mobile",
      text: "Phone",
      formatter: (cell, row, rowIndex) => {
        return cell
      },
    },
    {
      dataField: "pin_code",
      text: "Pincode",
      formatter: (cell, row, rowIndex) => {
        return cell
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row, rowIndex) => {
        if (cell === 'pending') {
          return (<span className="text-danger">{cell}</span>)
        } else {
          return (<span className="text-success">{cell}</span>)
        }
      },
    },
    {
      dataField: "paymentStatus",
      text: "Payment Status",
      formatter: (cell, row, rowIndex) => {
        if (cell === 'pending') {
          return (<span className="text-danger">{cell}</span>)
        } else {
          return (<span className="text-success">{cell}</span>)
        }
      },
    },
    {
      dataField: "requestDate",
      text: "Request Date And Time",
      formatter: (cell, row, rowIndex) => {
        return moment(cell).format('DD/MM/YYYY') + ' | ' + row.requestTime
      },
    },
    {
      dataField: "_id",
      text: "Action",
      hidden: !canManage,
      formatter: (cell, row, rowIndex) => {
        return (
          <div className="d-flex gap-1 flex-wrap" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              title="View Details"
              className="btn btn-sm"
              style={{ background: "#E8F2FB", color: "#1263AC", border: "1px solid #1263AC" }}
              onClick={(e) => { e.stopPropagation(); handleView && handleView(row); }}
            >
              <i className="fa fa-eye" /> View
            </button>
            {row.paymentStatus !== 'paid' && (
              <button
                type="button"
                title="Mark Payment Done"
                className="btn btn-sm btn-warning"
                onClick={(e) => { e.stopPropagation(); handleEdit(cell, 'payment'); }}
              >
                <i className="fa fa-credit-card" /> Payment Done
              </button>
            )}
            {row.status !== 'completed' && (
              <button
                type="button"
                title="Mark Service Done"
                className="btn btn-sm btn-success"
                onClick={(e) => { e.stopPropagation(); handleEdit(cell, 'service'); }}
              >
                <i className="fa fa-check" /> Service Done
              </button>
            )}
          </div>
        )
      },
    }
  ];
};

export default TableColumn;
